var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form"},[_c('div',{staticClass:"font-14 margin-top-20",staticStyle:{"color":"#909399"}},[_vm._v("默认样式")])])
}]

export { render, staticRenderFns }